export default "__VITE_ASSET__B7Rbvgeq__"